import { render, staticRenderFns } from "./MoneyLog.vue?vue&type=template&id=01a1225c&scoped=true"
import script from "./MoneyLog.vue?vue&type=script&lang=js"
export * from "./MoneyLog.vue?vue&type=script&lang=js"
import style0 from "./MoneyLog.vue?vue&type=style&index=0&id=01a1225c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a1225c",
  null
  
)

export default component.exports